var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:!px-10 !px-5"},[_c('MainTop'),_c('AllUserCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }